import React from 'react';
import { motion } from 'framer-motion';
import { FileWarning, Clock, MessageSquareDashed, LineChart } from 'lucide-react';
export function Problems() {
  const problems = [{
    icon: <FileWarning size={24} data-id="element-133" />,
    title: 'Content without conversion',
    description: 'You have hundreds of blog posts generating traffic, but zero measurable impact on your sales pipeline or demo requests.',
    metric: '0% ROI'
  }, {
    icon: <Clock size={24} data-id="element-134" />,
    title: 'Inconsistent publishing',
    description: 'Marketing teams treat content as an afterthought. No sustainable engine, leading to sporadic updates and lost momentum.',
    metric: 'Erratic'
  }, {
    icon: <MessageSquareDashed size={24} data-id="element-135" />,
    title: 'Generic messaging',
    description: 'Your content sounds exactly like your competitors. It lacks technical depth and fails to resonate with sophisticated B2B buyers.',
    metric: 'High Bounce'
  }, {
    icon: <LineChart size={24} data-id="element-136" />,
    title: 'No measurement framework',
    description: "Inability to tie content consumption to revenue. You know content is important, but can't prove its financial value to leadership.",
    metric: 'Blind Spot'
  }];
  return <section className="py-24 bg-slate-50 relative" data-id="element-137">
      <div className="absolute inset-0 bg-grid-pattern opacity-[0.03] pointer-events-none" data-id="element-138"></div>

      <div className="container mx-auto px-6 max-w-7xl relative z-10" data-id="element-139">
        <div className="mb-16 md:mb-24 max-w-3xl" data-id="element-140">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex items-center gap-3 mb-6" data-id="element-141">
            <div className="w-3 h-3 bg-navy-900 clip-triangle" data-id="element-142"></div>
            <span className="text-navy-600 font-medium uppercase tracking-wider text-sm" data-id="element-143">
              The Status Quo
            </span>
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-heading font-bold text-navy-900 leading-tight" data-id="element-144">
            SaaS content marketing is broken.
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-slate-200 border border-slate-200" data-id="element-145">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-10 md:p-14 group hover:bg-navy-900 hover:text-white transition-colors duration-300" data-id="element-146">
              <div className="flex justify-between items-start mb-8" data-id="element-147">
                <div className="w-12 h-12 bg-slate-100 text-navy-900 flex items-center justify-center group-hover:bg-navy-800 group-hover:text-white transition-colors" data-id="element-148">
                  {problem.icon}
                </div>
                <div className="font-mono text-xs font-bold text-slate-400 group-hover:text-navy-400 uppercase tracking-widest border border-slate-200 group-hover:border-navy-700 px-3 py-1" data-id="element-149">
                  {problem.metric}
                </div>
              </div>
              <h3 className="text-xl font-heading font-bold mb-4 text-navy-900 group-hover:text-white" data-id="element-150">
                {problem.title}
              </h3>
              <p className="text-slate-600 group-hover:text-slate-300 leading-relaxed" data-id="element-151">
                {problem.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}